import { Navigate } from 'react-router-dom';
import { useSessionStorage } from '../../hooks';
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../../AppContext';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  MainContainer,
  BoxContainer,
  BoxTitle,
  BoxStats,
  StatusBox,
  Status,
  ProgressContainer,
  ProgressBar,
  BoxTitleContainer,
  BoxGraphContainer,
  GraphContainer,
  Graph,
  GraphHeading,
  BoxFooter,
  BoxFooterTitle,
  BoxFooterButtonContainer,
  GotoScanButton,
  ButtonIcon,
  ActiveCarContainer,
  ActiveCar,
  BoxFooterActiveTitle,
  BoxFooterActiveCarOwner,
  StyledNotification,
  OuterCircleWrapper,
  InnerSpinner

} from './styled';


import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import leftarrow from '../../assets/leftarrow.svg';
import Active_Car from '../../assets/ToyotaLandCruiser2022.png';
import { FrontLineWorker } from './frontlineworker';
import { AllScan } from './allscan';
import * as apiClient from "../../common/apiClient";
import * as App_Constant from "../../common/constants";
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import './slider.css';
import {
  Spinner,
  SpinnerSize,

} from '../../components';
export const Dashboard = () => {
  const [authenticated, setAuthenticated] = useSessionStorage('authenticated');
  const [totalActiveScan, setTotalActiveScan] = useState(0);
  const [isLoadingActiveScan, setIsLoadingActiveScan] = useState(true);
  const [activeScan, setActiveScan] = useState<any[]>([]);
  const [isLoadingActiveCars, setIsLoadingActiveCars] = useState(true);
  const [activeCars, setActiveCars] = useState<any[]>([]);
  const [activeFLW, setActiveFLW] = useState<any[]>([]);
  const [remainingSeconds, setRemainingSeconds] = useState(App_Constant.AUTO_REFRESH_INTERVAL); // Set your desired interval
  const [lastRefreshTime, setLastRefreshTime] = useState<any>(null);

  const navigate = useNavigate();
  const { state, dispatch } = useAppContext();

  useEffect(() => {
    loadActiveScan();
    loadActiveCar();
    //loadActiveFLW();
  }, []);

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      // Call the API to refresh activeScan
      loadActiveScan();
      loadActiveCar();
      // loadActiveFLW();
      setLastRefreshTime(new Date()); // Update last refresh time
      setRemainingSeconds(App_Constant.AUTO_REFRESH_INTERVAL); // Reset remaining seconds
    }, App_Constant.AUTO_REFRESH_INTERVAL * 1000);

    // Clear interval on component unmount
    return () => clearInterval(refreshInterval);
  }, []); // Removed [remainingSeconds]

  // Update remaining seconds and last refresh time every second
  useEffect(() => {
    const countdownInterval = setInterval(() => {
      if (remainingSeconds > 0) {
        setRemainingSeconds((prev) => prev - 1);
      } else {
        setLastRefreshTime(new Date());
        setRemainingSeconds(App_Constant.AUTO_REFRESH_INTERVAL);
      }
    }, 1000);

    // Clear interval on component unmount
    return () => clearInterval(countdownInterval);
  }, [remainingSeconds]);

  const calculateLastRefreshTime = (lastRefreshTime: any) => {
    if (!lastRefreshTime) return 'Unknown';
    let now = new Date();
    const secondsDiff = Math.floor((now.getTime() - lastRefreshTime.getTime()) / 1000);
    return secondsDiff;
  };

  const loadActiveScan = () => {
    // setActiveScan([]);
    apiClient.get(`requests/getactiveRequests/${localStorage.getItem("business_partner_id")}/3`, null).then((response: any) => {
      if (response) {
        setActiveScan(response.activeScan);
        setTotalActiveScan(parseInt(response.totalActiveScan));
      }
      setIsLoadingActiveScan(false);
    }).catch((err) => {
      setIsLoadingActiveScan(false);
    })
  };

  const loadActiveCar = () => {
    //setActiveCars([]);
    apiClient.get(`requests/getactiveRequests/${localStorage.getItem("business_partner_id")}/1000000`, null).then((response: any) => {
      if (response) {
        setActiveCars(response.activeScan);

      }
      setIsLoadingActiveCars(false);
    }).catch((err) => {
      setIsLoadingActiveCars(false);
    })
  };

  if (authenticated)
    return (

      <MainContainer>
        {(

          <StyledNotification>
            Auto-refreshing in {remainingSeconds} secs. Last refreshed {calculateLastRefreshTime(lastRefreshTime)} seconds ago.
          </StyledNotification>

        )}
        <BoxContainer>
          <Box>
            <BoxTitleContainer>

              <BoxTitle>Total Active Scans </BoxTitle>
              <BoxStats>{totalActiveScan}</BoxStats>
            </BoxTitleContainer>
            <BoxGraphContainer >
              {activeScan != null && activeScan != undefined && activeScan.length > 0 && activeScan.map((item, index) => {
                return <GraphContainer>
                  <GraphHeading>VIN: {item.vin_no}</GraphHeading>
                  <Graph>
                    {/* <CircularProgressbar background={false} counterClockwise={true} value={item.step_value!=null?parseFloat(item.step_value):0}
                      strokeWidth={11}
                      text={`${item.step_value!=null?parseFloat(item.step_value):0}%`}
                      styles={buildStyles({
                        rotation: 0.25,
                        strokeLinecap: 'butt',
                        textSize: '22px',
                        pathTransitionDuration: 0.5,
                        pathColor: `#FBBC05`,
                        textColor: '#000',
                        trailColor: ' #00000000',
                      })}
                    /> */}

                    <OuterCircleWrapper>
                      <CircularProgressbar
                        value={item.step_value}
                        strokeWidth={10}
                        text={`${item.step_value != null ? item.step_value : 0}%`}
                        styles={buildStyles({
                          rotation: 0,
                          strokeLinecap: 'butt',
                          textSize: '16px',
                          pathTransitionDuration: 0.5,
                          pathColor: `#FBBC05`,
                          textColor: '#000',
                          trailColor: ' #00000000',
                        })}
                      />
                      <InnerSpinner />
                    </OuterCircleWrapper>

                  </Graph>
                </GraphContainer>
              })}
              {isLoadingActiveScan &&
                <GraphContainer>
                  <Spinner size={SpinnerSize.SMALL} />
                </GraphContainer>
              }


            </BoxGraphContainer>
            {!isLoadingActiveScan && totalActiveScan > 0 && <BoxFooter>
              <BoxFooterTitle>
                View All Active Scans
              </BoxFooterTitle>
              <BoxFooterButtonContainer>
                <GotoScanButton onClick={() => {
                  dispatch({ type: 'UPDATE_TOP_HEADER_TITLE', payload: 'All Scan' });
                  navigate('/allscan');

                }}>
                  <ButtonIcon src={leftarrow} />
                </GotoScanButton>
              </BoxFooterButtonContainer>

            </BoxFooter>
            }
          </Box>

          <Box>
            {!isLoadingActiveCars && <AwesomeSlider >
              {activeCars != null && activeCars != undefined && activeCars.length > 0 && activeCars.map((item, index) => {
                return <>
                  <BoxTitleContainer>
                    <BoxTitle  >Currently Scanning Car</BoxTitle>
                    <StatusBox  >
                      <Status>Status</Status>
                      <ProgressContainer >
                        <ProgressBar style={{ width: parseInt(item.step_value) - 5 }}></ProgressBar>
                      </ProgressContainer>
                    </StatusBox>
                  </BoxTitleContainer>
                  <ActiveCarContainer>
                    <ActiveCar src={item.img_url ? item.img_url : Active_Car} />
                  </ActiveCarContainer>
                  <BoxFooter>
                    <BoxFooterActiveTitle>
                      {item.car_name}
                    </BoxFooterActiveTitle>
                    <BoxFooterActiveCarOwner>
                      Owner: {item.first_name}{" "}{item.last_name}
                    </BoxFooterActiveCarOwner>
                  </BoxFooter></>
              })}
            </AwesomeSlider>}
          </Box>

        </BoxContainer>
        <FrontLineWorker data={activeFLW} />
        <AllScan />
      </MainContainer>


    );
  return <Navigate to='/' replace />;

};
